export function getClassName(classObject: {
    name: string
    displayName?: string
}) {
    if (!classObject) {
        return ''
    }

    if (classObject.displayName) {
        return classObject.displayName
    }

    return classObject.name
}
